import styled from "styled-components";

import { mobile } from "styles/breakpoints";
import { PrimaryButton } from "./PrimaryButton";

export const HeaderButton = styled(PrimaryButton)`
  border-radius: 0.5rem;
  height: 3rem;
  font-family: Roboto;

  @media ${mobile} {
    padding: 0.5rem 1rem;
    height: 2.5rem;
  }
`;